import { BASE_URL } from 'config';
import { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import DataTable from "examples/Tables/DataTable";
import categoriesTableData from "./data/categoriesTableData";
import TextField from "@mui/material/TextField";
import MDButton from "components/MDButton";
import AddCategoryModal from "components/AddCategoryModal";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { CircularProgress, Backdrop, Box } from "@mui/material";
import RowsPerPageSelector from "components/RowsPerPageSelector";

function Categories() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null); // Add current user state
  const [loading, setLoading] = useState(true);

  // Modify modal opening logic
  const handleEditClick = (user) => {
    setCurrentUser(user);
    setModalOpen(true);
  };
  useEffect(() => {
    fetchUsers();
  }, []);
  // get categories
  const fetchUsers = async () => {
    setLoading(true);
    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(
        BASE_URL + "/administrator/categories",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      setUsers(data.data || []);
      console.log(data.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
    setLoading(false);
  };

  const { columns, rows } = categoriesTableData(users, handleEditClick, fetchUsers);

  const filteredRows = rows.filter(
    (row) =>
      (row.author?.props?.name?.toLowerCase?.() || "").includes(search.toLowerCase()) ||
      (row.author?.props?.email?.toLowerCase?.() || "").includes(search.toLowerCase())
  );
  const paginatedRows = filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  useEffect(() => {
    setPage(0); // تصفير الصفحة عند تغيير البحث أو عدد الصفوف
  }, [search, rowsPerPage]);
  return (
    <>
      <Backdrop open={loading} sx={{ zIndex: 2000, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <AddCategoryModal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setCurrentUser(null);
        }}
        onUserAdded={fetchUsers}
        initialData={currentUser} // Pass current user data
      />

      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: "linear-gradient(90deg, #ca9937, #e0b15a)",
              boxShadow: 3,
            }}
          >
            <MDTypography variant="h6" color="white">
              كل الفئات
            </MDTypography>

            <MDButton
              variant="contained"
              color="white"
              startIcon={<AddIcon />}
              sx={{ color: "white" }}
              onClick={() => setModalOpen(true)}
            >
              فئة جديدة
            </MDButton>
          </MDBox>

          <MDBox pt={3} px={2}>
            <Box display="flex" gap={2}>


              <TextField
                fullWidth
                label="بحث بالاسم "
                variant="outlined"
                size="small"

                onChange={(e) => setSearch(e.target.value)}
              />
              <MDBox mb={2} display="flex">
                <RowsPerPageSelector value={rowsPerPage} onChange={setRowsPerPage} />
              </MDBox>
            </Box>
            <DataTable
              table={{ columns, rows: paginatedRows }}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={true}
              noEndBorder
              sx={{
                "& .MuiTable-root": { minWidth: 1000 },
                "& .MuiTableCell-root": {
                  py: 1.5,
                  borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                },
                "& .MuiTableHead-root": {
                  backgroundColor: (theme) => theme.palette.grey[100],
                },
              }}
            />
          </MDBox>

        </Card>
      </MDBox>
      <MDBox display="flex" justifyContent="center" mt={4} pb={4} px={2}>
        <MDButton
          onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
          disabled={page === 0}
          sx={{
            background: "linear-gradient(90deg, #ca9937, #e0b15a)",
            color: "text.main",
            borderRadius: "50%",
            width: "50px",
            height: "50px",
            minWidth: "50px",
            mx: 1,
            "&:hover": {
              background: "linear-gradient(90deg, #b6842f, #d39d45)",
            },
          }}
        >
          <ArrowForwardIcon />
        </MDButton>

        <MDTypography
          variant="button"
          color="text.main"
          sx={{
            display: "flex",
            alignItems: "center",
            mx: 3,
            fontWeight: "bold",
          }}
        >
          {page + 1} / {Math.ceil(filteredRows.length / rowsPerPage)}
        </MDTypography>

        <MDButton
          onClick={() =>
            setPage((prev) =>
              (prev + 1) * rowsPerPage >= filteredRows.length ? prev : prev + 1
            )
          }
          disabled={(page + 1) * rowsPerPage >= filteredRows.length}
          sx={{
            background: "linear-gradient(90deg, #ca9937, #e0b15a)",
            color: "text.main",
            borderRadius: "50%",
            width: "50px",
            height: "50px",
            minWidth: "50px",
            mx: 1,
            "&:hover": {
              background: "linear-gradient(90deg, #b6842f, #d39d45)",
            },
          }}
        >
          <ArrowBackIcon />
        </MDButton>
      </MDBox>
    </>
  );
}

export default Categories;
